import Cookies from "js-cookie";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useVerifyUserMutation } from "../../../service/authApi";
import { UserProfileData } from "../types/profileTypes";
import Button from "../../../components/button/button";

const VerifyButton: React.FC<{ user?: UserProfileData; className?: string }> = ({ user, className }) => {
  const [verifyUser, { isLoading }] = useVerifyUserMutation();
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();
  const email = user?.email;
  const firstName = user?.firstName;
  const handleVerifyButton = async () => {
    try {
      setError("");
      const response = await verifyUser({ email, firstName }).unwrap();
      Cookies.set("verifyToken", response.data.token);
      Cookies.set("encryptedOtp", response.data.Otp);
      navigate("/user/verify");
    } catch (e) {
      if (e && typeof e === "object" && "status" in e && "data" in e) {
        const error = e as { status: number; data: string };
        setError(error.data);
      } else {
        setError("unexpected error please try again later");
      }
    }
  };

  return (
    <>
      <Button
        isLoading={isLoading}
        type="button"
        size="medium"
        variant="primary"
        disabled={isLoading}
        onClick={handleVerifyButton}
        className={className}
      >
        {" "}
        Verify your Email{" "}
      </Button>
      {error && error.length > 0 && (
        <div className=" text-lg text-red-500 mt-7 w-full flex justify-center items-center">
          {error}
        </div>
      )}
    </>
  );
};

export default VerifyButton;
